import { cn } from '../../utils'
import { MenuItemProps } from './types'

/**
 *
 * @param id - The id of the menu item
 * @param label - The label of the menu item
 * @param itemIcon - The icon of the menu item
 * @param handleActive - The active state of the menu item
 * @param handleItemClick - The click event of the menu item
 * @param className - The class name of the menu item
 * @param labelClassName - The class name of the menu item label
 *
 */
export const MenuItem = ({
    id,
    label,
    itemIcon,
    handleActive,
    handleItemClick,
    className,
    labelClassName,
}: MenuItemProps) => {
    const onClickHandle = () => {
        handleItemClick()
        handleActive(id)
    }

    return (
        <div
            className={cn(
                'group inline-flex h-full w-full cursor-pointer gap-2 px-1.5 py-1.5 hover:bg-background-disabled/20',
                className
            )}
            onClick={onClickHandle}
        >
            {itemIcon && itemIcon}
            <div
                tabIndex={0}
                role="button"
                className={cn(
                    'px-1 py-2.5 font-sans text-2xs font-bold leading-tight text-color-title',
                    labelClassName
                )}
            >
                {label}
            </div>
        </div>
    )
}
